module.exports = __webpack_public_path__ + "static/media/plus.80011591.svg";